import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../commonDesign/SydModal'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../commonDesign/Button'
import Markup from '../../../../atoms/Markup'
import { labelStyle, valueStyle as baseValueStyle } from '../shared/redtailUIHelpers'
import MarkTaskButton from './MarkTaskButton'
import { isTaskCompleted, formatTaskDateLong } from './helpers'

const valueStyle = { ...baseValueStyle, marginBottom: '12px' }

function WoSfTaskDetailModal ({ open, onClose, task }) {
  if (!task) return null

  const dueFormatted = formatTaskDateLong(task.dueDate)
  const createdFormatted = formatTaskDateLong(task.createdDate)

  return (
    <SydModal
      open={open}
      onClose={onClose}
      title={task.subject || 'Task Details'}
      size='xmedium'
      disablePortal={false}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '24px' }}>
          {dueFormatted ? (
            <div>
              <div style={labelStyle}>Due Date</div>
              <div style={valueStyle}>{dueFormatted}</div>
            </div>
          ) : null}
          {createdFormatted ? (
            <div>
              <div style={labelStyle}>Created</div>
              <div style={valueStyle}>{createdFormatted}</div>
            </div>
          ) : null}
        </div>

        <div style={{ display: 'flex', gap: '24px' }}>
          {task.priority ? (
            <div>
              <div style={labelStyle}>Priority</div>
              <div style={valueStyle}>{task.priority}</div>
            </div>
          ) : null}
          {task.status ? (
            <div>
              <div style={labelStyle}>Status</div>
              <div style={valueStyle}>{task.status}</div>
            </div>
          ) : null}
        </div>

        <div style={labelStyle}>Description</div>
        {task.description ? (
          <div style={valueStyle}>
            <Markup value={task.description} type='html' style={{ fontSize: 'inherit' }} />
          </div>
        ) : (
          <div style={{ ...valueStyle, color: 'var(--text-color-subtle)', fontStyle: 'italic' }}>
            No description
          </div>
        )}

        {isTaskCompleted(task) ? (
          <div style={{
            fontSize: 'var(--font-size-sm)',
            color: 'var(--color-growth-500)',
            fontWeight: 600,
            marginBottom: '8px'
          }}
          >
            You have marked this task as complete
          </div>
        ) : null}
      </div>

      <SydModalActions>
        <SydButton variant='ghost' size='sm' onClick={onClose}>
          Close
        </SydButton>
        <MarkTaskButton
          taskId={task.id}
          currentlyCompleted={isTaskCompleted(task)}
          onSuccess={onClose}
          variant='primary'
          size='sm'
        />
      </SydModalActions>
    </SydModal>
  )
}

WoSfTaskDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  task: PropTypes.object
}

export default WoSfTaskDetailModal
